import OImage from "components/reusable/OImage";
import OInputField from "components/reusable/OInputField";
import useToastContext from "hooks/useToastContext";
import React, { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { apiPost } from "utils/apiFetch";
import apiPath from "utils/apiPath";
import photoClose from "../../assets/images/photo_close.png";

const AddHomeMenu = () => {
  const { t } = useTranslation();
  const notification = useToastContext();
  const iconRef = useRef()
  const navigate = useNavigate();
  const [icon, setIcon] = useState([]);
  const {
    register,
    setValue,
    // watch,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });

  const handleSubmitForm = async (data) => {
    let formData = new FormData();
    formData.append("image", icon[0]);
    formData.append("name", data?.name);
    formData.append("nameAr", data?.nameAr);
    formData.append("apiPath", data?.apiPath);
    formData.append("order", data?.order);
    try {
      const { data: response } = await apiPost(apiPath.appHomeMenu, formData);

      if (response?.success) {
        notification.success(response?.message);
        navigate("/app-home-menu");
      } else {
        notification.error(response?.message);
      }
    } catch (error) {
      notification.error(error?.message);
    }
  };

  const removePhotos = async (index, type) => {
    setIcon((prev) => {
      return prev?.filter((res) => res !== index);
    });
  };

  const handlePhotosChange = (e) => {
    const files = e.target.files;
    let images = [];
    for (let i = 0; i < files?.length; i++) {
      images.push(files[i]);
    }
    setIcon(images);
  };

  return (
    <div className="basic_info px-4 ">
      <form
        className="py-4"
        onSubmit={handleSubmit(handleSubmitForm, (submit) => {})}
      >
        <div className="">
          <div className="grid grid-rows-1 grid-cols-2 gap-4">
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="name"
                  inputLabel={<>Name</>}
                  type="text"
                  register={register("name", {
                    required: "Please enter name",
                  })}
                  errors={errors}
                />
              </label>
            </div>
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="nameAr"
                  inputLabel={<>Name (Arbic)</>}
                  type="text"
                  register={register("nameAr", {
                    required: "Please enter name (arbic)",
                  })}
                  errors={errors}
                />
              </label>
            </div>
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="apiPath"
                  inputLabel={<>URL</>}
                  type="text"
                  register={register("apiPath", {
                    required: "Please enter url",
                  })}
                  errors={errors}
                />
              </label>
            </div>
            <div className="mb-3">
              <label className="block">
                <OInputField
                  wrapperClassName="relative z-0   w-full group"
                  name="order"
                  inputLabel={<>Order</>}
                  type="number"
                  register={register("order", {
                    required: "Please enter order",                    
                    min: {
                      value: 1,
                      message: 'Minimum order must be 1.'
                    },
                  })}
                  errors={errors}
                />
              </label>
            </div>
          </div>
          <div className="grid grid-rows-1 grid-cols-1 gap-4">
            <h4 className="text-lg font-semibold py-3">Icon</h4>
            <div className="photo_list flex flex-wrap gap-5">
            <div
                className='p-3 w-[164px]  xl:w-[204px] h-[204px] border-dashed rounded-md border flex items-center justify-center cursor-pointer'
                onClick={() => iconRef?.current?.click()}
              >
                <div className='text-center'>
                  <img
                    src='../images/uploadimg.png'
                    className='m-auto'
                    alt=''
                  />
                  <strong className='my-2 block text-xl'>
                    {t('ADD_PHOTO')}
                  </strong>                
                  <input
                    type="file"
                    accept='image/png, image/jpg, image/jpeg'
                    name='icon'
                    ref={iconRef}
                    onChange={(e) => handlePhotosChange(e)}
                    className='hidden'
                  />
                </div>
              </div>
              {/* <div className="p-3 w-[164px]  xl:w-[204px] h-[204px] border-dashed rounded-md border flex items-center justify-center cursor-pointer">
                <input
                  type="file"
                  accept="image/png, image/jpg, image/jpeg, image/svg+xml"
                  name="image"
                  // ref={photosRef}
                  onChange={(e) => handlePhotosChange(e)}
                />
              </div> */}

              {icon?.length > 0 && (
                <div
                  style={{ cursor: "move" }}
                  className="w-[164px] h-[164px] xl:w-[204px] xl:h-[204px] rounded-md relative overflow-hidden"
                >
                  <figure className="w-full h-full">
                    <OImage
                      src={
                        typeof icon === "object"
                          ? URL.createObjectURL(icon[0])
                          : icon
                      }
                      fallbackUrl="/images/user.png"
                      className="w-full h-full object-cover"
                      alt=""
                    />
                  </figure>

                  <button
                    type="button"
                    className="absolute top-[10px] right-[10px]"
                    onClick={() => removePhotos(icon[0])}
                  >
                    <img src={photoClose} alt="" />
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="border-t mt-10 py-10 text-center">
            <button className="bg-lime-500 hover:bg-[#8FC150] cursor-pointer   text-white  font-normal active:bg-slate-100 text-md px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150">
              {t("SAVE")}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddHomeMenu;
